import React from 'react';
import { Box, TextField, Stack, Alert } from '@mui/material';

const StandupComposer = ({ form, onChange, disabled }) => {
  return (
    <Box>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ mb: 1 }}>
        <TextField
          size="small"
          label="What I did yesterday"
          fullWidth
          multiline
          minRows={2}
          value={form.yesterday || ''}
          onChange={(e) => onChange({ ...form, yesterday: e.target.value })}
          disabled={disabled}
        />
        <TextField
          size="small"
          label="What I'm doing today"
          fullWidth
          multiline
          minRows={2}
          value={form.today || ''}
          onChange={(e) => onChange({ ...form, today: e.target.value })}
          disabled={disabled}
        />
      </Stack>
      <TextField
        fullWidth
        multiline
        minRows={2}
        label="What I need help with"
        value={form.blockers || ''}
        onChange={(e) => onChange({ ...form, blockers: e.target.value })}
        disabled={disabled}
      />
      <TextField
        fullWidth
        multiline
        minRows={2}
        label="Stretch updates"
        value={form.stretch || ''}
        onChange={(e) => onChange({ ...form, stretch: e.target.value })}
        disabled={disabled}
        sx={{ mt: 1 }}
      />
      <Alert severity="info" sx={{ mt: 1 }}>
        Stand-up posts are not implemented yet. This is a stub UI.
      </Alert>
    </Box>
  );
};

export default StandupComposer;
